<template>
  <div class="code-editor">
    <!-- テキストエディタ -->
    <template v-if="showTabContent" class="code-content">
      <code-mirror-editor
        :mode="'htmlmixed'"
        :code="codePartBody"
        @change="changeCode($event)"
      />
      <!-- 使用例 -->
      <div>
        <div class="code-part-example">
          <div class="mphe-attr-description">
            <p>以下の独自属性を指定すると該当部分のコンテンツを編集できるようになります</p>
          </div>
          <div class="mphe-attr">
            <p class="attr-title">data-mphe-edit：タグ編集(テキスト)</p>
            <div class="attr-content">
              <ul>
                <li>属性を指定した部分のテキストを変更できるようになります</li>
              </ul>
              <code>{{ dataMPHEEditExample }}</code>
            </div>
          </div>
          <div class="mphe-attr">
            <p class="attr-title">data-mphe-link：タグ編集(リンク)</p>
            <div class="attr-content">
              <ul>
                <li>属性を指定した a タグのリンク先を変更できるようになります</li>
                <li>data-mphe-editと併用することでリンクテキストも変更できます</li>
              </ul>
              <code>{{ dataMPHELinkExample }}<br/>{{ dataMPHELinkExample2 }}</code>
            </div>
          </div>
          <div class="mphe-attr">
            <p class="attr-title">data-mphe-image：タグ編集(画像)</p>
            <div class="attr-content">
              <ul>
                <li>img 要素に指定することで画像を設定できるようになります</li>
                <li>画像の横幅はHTMLソースに指定してください(推奨：最大600px)</li>
              </ul>
              <code>{{ dataMPHEImageExample }}</code>
            </div>
          </div>
          <div class="mphe-attr">
            <p class="attr-title">data-mphe-label：ラベル</p>
            <div class="attr-content">
              <ul>
                <li>コンテンツタブで表示する見出しを指定できます</li>
                <li>この属性はエクスポート時に生成されるHTMLには反映されません</li>
              </ul>
              <code>{{ dataMPHELabelExample }}</code>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- タグ編集 -->
    <template v-if="showTabTag">
      <code-tag-editor
        :current="current"
        :code="codePartBody"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
        :partId="partId"
        :part="parts[0]"
        @change="changeCode($event)"
      />
    </template>
  </div>
</template>

<script>
import CodeMirrorEditor from '@/components/Content/Palette/EditPartDesign/Editor/Code/CodeMirrorEditor'
import CodeTagEditor from '@/components/Content/Palette/EditPartDesign/Editor/Code/CodeTagEdit'

export default {
  props: [
    'current',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partId'
  ],
  components: {
    CodeMirrorEditor,
    CodeTagEditor
  },
  data () {
    return {
      env: process.env.VUE_APP_ENV
    }
  },
  computed: {
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabTag () {
      return this.current.tab === 'Tag'
    },
    codePartBody () {
      if (!this.parts) return null
      return this.parts[0].body
    },
    dataMPHEEditExample () {
      return `<p data-mphe-edit="CUSTOM">ここのテキストが編集可能です</p>`
    },
    dataMPHELinkExample () {
      return `<a data-mphe-link="CUSTOM">リンク先のみ編集</a>`
    },
    dataMPHELinkExample2 () {
      return `<a data-mphe-edit="CUSTOM" data-mphe-link="CUSTOM">リンクテキストも編集</a>`
    },
    dataMPHEImageExample () {
      return `<img data-mphe-image="CUSTOM" width="600"/>`
    },
    dataMPHELabelExample () {
      return `<p data-mphe-edit="CUSTOM" data-mphe-label="テキスト1">ここのテキストが編集可能です</p>`
    }
  },
  methods: {
    changeCode (value) {
      this.$emit('input', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        body: value
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// コードパーツ使用例
.code-editor {
  .code-part-example {
    font-size: 14px;
    padding-top: 10px;
    .mphe-attr {
      padding: 5px 10px 10px 20px;
      &-description {
        padding: 5px 10px;
        font-weight: 700;
      }
      ul {
        list-style-type: disc;
        font-size: 12px;
        padding-left: 20px;
        padding-bottom: 5px;
        li {
          padding-bottom: 3px;
        }
      }
      code {
        background: #dcdcdc;
        font-size: 12px;
        color: #666;
        padding: 10px;
        display: block;
        border-radius: 2px;
      }
      .attr-title {
        font-weight: 600;
        padding-bottom: 5px;
      }
      .attr-content {
        padding-left: 10px;
      }
    }
  }
}
</style>
